import { NavLink, useLocation } from 'react-router-dom';
import { getDocIndex } from '../../lib/docs';
import { Icon, type IconName } from '../Icon';
import { DocsSearch } from './DocsSearch';

interface DocsSidebarProps {
    onNavigate?: () => void;
}

/**
 * Sidebar gauche de la documentation : sections repliables + pages enfants.
 * La section active est ouverte automatiquement.
 */
export function DocsSidebar({ onNavigate }: DocsSidebarProps) {
    const { sections } = getDocIndex();
    const location = useLocation();
    const current = location.pathname;

    return (
        <nav className="docs-sidebar" aria-label="Navigation de la documentation">
            <div className="docs-sidebar-search">
                <DocsSearch onNavigate={onNavigate} />
            </div>

            <div className="docs-sidebar-tree">
                <NavLink
                    to="/docs"
                    end
                    className={({ isActive }) =>
                        `docs-nav-link is-root${isActive ? ' is-active' : ''}`
                    }
                    onClick={onNavigate}
                >
                    <Icon name="home" size={14} />
                    <span>Accueil</span>
                </NavLink>

                {sections.map((section) => {
                    const sectionActive = current.startsWith(`/docs/${section.id}`);
                    return (
                        <div
                            key={section.id}
                            className={`docs-nav-section${sectionActive ? ' is-open' : ''}`}
                        >
                            <NavLink
                                to={section.indexPath}
                                className={({ isActive }) =>
                                    `docs-nav-section-head${isActive ? ' is-active' : ''}`
                                }
                                onClick={onNavigate}
                            >
                                <Icon
                                    name={(section.icon ?? 'book') as IconName}
                                    size={14}
                                />
                                <span>{section.label}</span>
                            </NavLink>

                            {sectionActive && (
                                <ul className="docs-nav-section-list">
                                    {section.pages.map((page) => (
                                        <li key={page.path}>
                                            <NavLink
                                                to={page.path}
                                                className={({ isActive }) =>
                                                    `docs-nav-page${
                                                        isActive ? ' is-active' : ''
                                                    }`
                                                }
                                                onClick={onNavigate}
                                            >
                                                {page.frontmatter.title}
                                                {page.frontmatter.status &&
                                                    page.frontmatter.status !== 'stable' && (
                                                        <span
                                                            className={`doc-status doc-status-${page.frontmatter.status} is-mini`}
                                                        >
                                                            {page.frontmatter.status === 'beta'
                                                                ? 'Bêta'
                                                                : 'Bientôt'}
                                                        </span>
                                                    )}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    );
                })}
            </div>
        </nav>
    );
}
